/**
 * Update Last Accessed API
 * PATCH /api/path-enrollments/{enrollmentId}/last-accessed
 *
 * Resume write-back: fired (debounced) by the viewer on item navigation.
 * Always stamps last_accessed_at; the resume pointer only moves when the
 * engine reports the item available or completed.
 */

import axiosInstance from "../axiosInstance";

export interface UpdateLastAccessedResponse {
  id: number;
  lastAccessedAt: string;
  currentItemId: number | null;
  currentStepId: number | null;
  pointerMoved: boolean;
}

interface UpdateLastAccessedEnvelope {
  data: UpdateLastAccessedResponse;
}

export const updateLastAccessed = async (
  enrollmentId: number,
  itemId: number,
): Promise<UpdateLastAccessedResponse> => {
  const response = await axiosInstance.patch<UpdateLastAccessedEnvelope>(
    `/api/path-enrollments/${enrollmentId}/last-accessed`,
    { itemId },
  );

  return response.data.data;
};
